import { render, staticRenderFns } from "./TemplateLoading.vue?vue&type=template&id=7c0f68e4&scoped=true&"
import script from "./TemplateLoading.ts?vue&type=script&lang=ts&"
export * from "./TemplateLoading.ts?vue&type=script&lang=ts&"
import style0 from "./TemplateLoading.scss?vue&type=style&index=0&id=7c0f68e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0f68e4",
  null
  
)

export default component.exports